import { Icon } from "@uigovpe/components";
import { useImageSource } from "@/hooks/images/useImageSource";
import type { ProductImage } from "../types";

type Props = {
  image: ProductImage;
  isMain?: boolean;
  onRemove: () => void;
  onView: () => void;
};

export default function ImagePreview({
  image,
  isMain = false,
  onRemove,
  onView,
}: Props) {
  const { imageSource } = useImageSource(image.url);
  return (
    <div
      className={
        isMain
          ? "group relative! flex! h-72! w-full! items-center! justify-center! overflow-hidden! rounded-sm! border! border-dashed! border-violet-light! bg-zinc-100! md:h-80!"
          : "group relative! flex! size-20! items-center! justify-center! overflow-hidden! rounded-md! bg-zinc-200!"
      }
    >
      <img
        src={imageSource}
        alt={image.name}
        className={
          isMain
            ? "block! h-full! w-full! object-contain! object-center!"
            : "h-full! w-full! object-cover!"
        }
      />
      {isMain && (
        <span className="absolute! top-3! left-3! flex! items-center! gap-1! rounded-full! bg-white! px-3! py-1! text-xs! font-medium! text-[#4e3873]! shadow-sm!">
          <Icon icon="star" className="text-[16px]!" />
          Principal
        </span>
      )}
      <div className="pointer-events-none! absolute! inset-0! z-20! flex! items-center! justify-center! gap-3! bg-zinc-950/55! opacity-0! transition-opacity! duration-200! group-hover:pointer-events-auto! group-hover:opacity-100! group-focus-within:pointer-events-auto! group-focus-within:opacity-100!">
        <button
          type="button"
          onClick={onView}
          aria-label={`Visualizar ${image.name}`}
          className="flex! size-9! cursor-pointer! items-center! justify-center! rounded-sm! border-0! bg-white! text-[#4e3873]! shadow-sm!"
        >
          <Icon icon="visibility" outline />
        </button>
        <button
          type="button"
          onClick={onRemove}
          aria-label={`Apagar ${image.name}`}
          className="flex! size-9! cursor-pointer! items-center! justify-center! rounded-sm! border-0! bg-white! text-[#4e3873]! shadow-sm!"
        >
          <Icon icon="delete" outline />
        </button>
      </div>
    </div>
  );
}
